import { render, staticRenderFns } from "./GenerarPassword.vue?vue&type=template&id=98dc52c4&"
import script from "./GenerarPassword.vue?vue&type=script&lang=js&"
export * from "./GenerarPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports